module.exports = {"url":"https://ship-zone.com","filePath":"https://ship-zone.com"}


//////////////////
// WEBPACK FOOTER
// ./src/baseurl.json
// module id = 1171
// module chunks = 0